import type {
  ProductPrice,
  ProductVariant,
  ProductWithVariants,
} from '@/src/core/domain/entities/product'
import {productHasManyVariants} from '@/src/entities/product/helpers/validators'
import {action, computed, makeObservable, observable, override} from 'mobx'
import {ProductListItemViewModel} from './list-item-simple'
import {ProductVariantsStore} from './variants'
import type {BasketStoreInterface} from '@/src/presentation/stores/basket/basket.store.interface'
import {getInjection} from '@runlab/di'
import {ProductListEvents} from '@/src/core/domain/events/product.events'

export class ProductWithVariantsListItemViewModel extends ProductListItemViewModel {
  declare product: ProductWithVariants

  @observable
  attributes!: {
    showModal: boolean
  }

  @observable
  variants!: ProductVariantsStore

  constructor(
    product: ProductWithVariants,
    // TODO: выпилить onClickBuyButtonDesktop и onClickBuyButtonMobile
    onClickBuyButtonDesktop?: (variant?: ProductVariant) => void,
    onClickBuyButtonMobile?: (variant?: ProductVariant) => void,
    basket?: BasketStoreInterface,
  ) {
    super(product, onClickBuyButtonDesktop, onClickBuyButtonMobile, basket)

    this.variants = new ProductVariantsStore(product)

    this.attributes = {
      ...this.attributes,
      showModal: false,
    }

    this.variants.resolveInitialVariant()

    makeObservable(this)
  }

  @override
  get inBasket() {
    return this.basket?.haveProduct(this.product, this.variants.variant ?? undefined) ?? false
  }

  @computed
  get attributesModalKey() {
    return (key: React.Key) => `${String(key)}-${(this.attributes.showModal && '+') || '-'}`
  }

  @override
  get price(): Nullable<ProductPrice> {
    return this.variants.price
  }

  @override
  get available() {
    return (this.variants.variant && this.variants.variant.available) || false
  }

  @computed
  get availableAttributes() {
    return this.variants.availableAttributes
  }

  @override
  setBasket(basket: BasketStoreInterface) {
    super.setBasket(basket)
  }

  @action.bound
  showAttributesModal(open: boolean) {
    this.attributes.showModal = open
  }

  async onClickBuyButton(device?: 'mobile' | 'desktop'): Promise<void> {
    this.setLoading(true)

    const variant = this.variants.variant ?? undefined

    if (device == 'mobile') {
      if (productHasManyVariants(this.product) && !this.attributes.showModal) {
        this.showAttributesModal(true)
      } else {
        await getInjection('IEventBus').publish(
          ProductListEvents.buyProduct({product: this.product, variant}),
        )
        // await this.basket?.addProduct(this.product, variant)
      }
    } else if (device == 'desktop') {
      await getInjection('IEventBus').publish(
        ProductListEvents.buyProduct({product: this.product, variant}),
      )
      // await this.basket?.addProduct(this.product, variant)
    }

    this.setLoading(false)
  }
}
